




















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Navigation from '@/components/layout/Navigation.vue'
import Cover from '@/components/layout/Cover.vue'
import Headline from '@/components/layout/Headline.vue' // @ is an alias to /src
import jQuery from 'jquery'
const $ = jQuery.noConflict()

@Component({
  components: {
    Headline,
    Navigation,
    Cover
  }
})
export default class Kontakt extends Vue {
  // data
  firma: string = ''
  vorname: string = ''
  nachname: string = ''
  email: string = ''
  phone: string = ''
  message: string = ''
  service: string = ''
  response: any = false
  loading = false

  // methods
  async submitAngebot() {
    this.loading = true
    //data to be sent to server
    const postData = {
      userFirma: this.firma,
      userName: this.vorname + ' ' + this.nachname,
      userEmail: this.email,
      userPhone: this.phone,
      userMessage: this.message
    }
    //Ajax post data to server
    $.post(
      '/contact.php',
      postData,
      (response: any) => {
        this.response = response
        if (this.response.type === 'message') {
          this.firma = ''
          this.vorname = ''
          this.nachname = ''
          this.email = ''
          this.phone = ''
          this.message = ''
          this.$ga.event('SUCCESS', 'Kontakt')
        } else this.$ga.event('ERROR', 'Kontakt')
        this.loading = false
      },
      'json'
    )
  }
}
